"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributes = void 0;
const react_1 = require("react");
const types_1 = require("@groupby/enrich-sdk/resource/_jsonapi/types");
const predicate_language_1 = require("@groupby/predicate-language");
const react_redux_1 = require("react-redux");
const formal_attributes_1 = require("../formal-attributes");
const feature_flags_1 = require("../../feature-flags");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const store_1 = require("../../store");
const useAttributes = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isMultiFacetNavEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFacetNav);
    const client = (0, hooks_1.useEnrichClient)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { addError } = (0, hooks_1.useNotification)();
    const token = (0, hooks_1.useToken)();
    const selectedOrganizations = (0, store_1.useSelectedOrganizationsSelector)();
    const attributes = (0, store_1.useAttributesSelector)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { loadFormalAttributes, getAttributeName, isLoading: areFormalAttributesLoading } = (0, formal_attributes_1.useFormalAttributes)();
    const loadAttributes = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        setIsLoading(true);
        const payload = { response: {} };
        try {
            yield client.products.getPage({
                filter: (0, predicate_language_1.where)((0, predicate_language_1.f) `organizationId`, '@<', selectedOrganizations.map(({ id }) => (0, predicate_language_1.uuid)(id))),
                fields: { meta: [types_1.CollectionMetaParam.REFINEMENTS] },
                page: {
                    limit: 0,
                },
            }, payload);
            const attributes = (_d = (_c = (_b = (_a = payload.response.meta) === null || _a === void 0 ? void 0 : _a.beta) === null || _b === void 0 ? void 0 : _b.refinements) === null || _c === void 0 ? void 0 : _c.actualAttributes) !== null && _d !== void 0 ? _d : [];
            dispatch((0, store_1.attributesSetAttributes)({ attributes, isMultiFacetNavEnabled }));
        }
        catch (e) {
            addError(t({ key: 'PRODUCT_REFINEMENTS_LOADING_ERROR' }));
            dispatch((0, store_1.attributesSetAttributes)({ attributes: [], isMultiFacetNavEnabled }));
        }
        finally {
            setIsLoading(false);
        }
    }), [addError, client, dispatch, selectedOrganizations, t, isMultiFacetNavEnabled]);
    (0, react_1.useEffect)(() => {
        if (selectedOrganizations.length && token) {
            void loadAttributes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOrganizations, token]);
    const actualAttributeNameIds = (0, react_1.useMemo)(() => Array.from(new Set(attributes.map(({ attributeId }) => attributeId))), [attributes]);
    (0, react_1.useEffect)(() => {
        if (actualAttributeNameIds.length) {
            void loadFormalAttributes(actualAttributeNameIds.map((id) => ({ attributeId: id })));
        }
    }, [actualAttributeNameIds, loadFormalAttributes]);
    const attributeNameOptions = (0, react_1.useMemo)(() => actualAttributeNameIds.map((id) => ({ id, label: getAttributeName(id) })), [actualAttributeNameIds, getAttributeName]);
    return {
        isLoading: isLoading || areFormalAttributesLoading,
        attributeNameOptions,
        areFormalAttributesLoading,
    };
};
exports.useAttributes = useAttributes;
